export default __webpack_public_path__ + "static/media/login-embelishment-2.e874b165.svg";